import React from "react";
import { Card } from "react-bootstrap";
import "./ListCardNew.css";

const ListCardNew = ({ title, list = [] }) => {
  return (
    <Card className="list_card">
      {title && <h4 className="list_card_title">{title}</h4>}

      <div className="list_card_content">
        <ul>
          {list.length > 0 ? (
            list.map((item, index) => <li key={index}>{item}</li>)
          ) : (
            <li className="list_card_content_li">No items available</li>
          )}
        </ul>
      </div>
    </Card>
  );
};

export default ListCardNew;
